/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TabDetailDto } from '../../models/tab-detail-dto';

export interface PosTabsControllerGetDetail$Params {
  id: string;
}

export function posTabsControllerGetDetail(http: HttpClient, rootUrl: string, params: PosTabsControllerGetDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<TabDetailDto>> {
  const rb = new RequestBuilder(rootUrl, posTabsControllerGetDetail.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TabDetailDto>;
    })
  );
}

posTabsControllerGetDetail.PATH = '/pos/tabs/{id}/detail';
